import request from '@/utils/request'
import axios from 'axios'

const BASE = '/inventory-management-api/material'

const exportRequest = (url, data) => {
  const sessionId = localStorage.getItem('sessionId') || ''
  return axios({
    url,
    method: 'POST',
    data: { sessionId, data: data || {} },
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json' },
    baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
    timeout: 60000
  })
}

export const materialApi = {
  // Material master
  saveMaterial(data) { return request({ url: `${BASE}/save`, method: 'POST', data }) },
  listMaterial(data) { return request({ url: `${BASE}/list`, method: 'POST', data: data || {} }) },
  optionsMaterial(data) { return request({ url: `${BASE}/options`, method: 'POST', data: data || {} }) },
  deleteMaterial(id) { return request({ url: `${BASE}/delete`, method: 'POST', data: { id } }) },
  adjustStock(data) { return request({ url: `${BASE}/adjustStock`, method: 'POST', data }) },

  // Purchase
  savePurchase(data) { return request({ url: `${BASE}/purchase/save`, method: 'POST', data }) },
  listPurchase(data) { return request({ url: `${BASE}/purchase/list`, method: 'POST', data }) },
  deletePurchase(id) { return request({ url: `${BASE}/purchase/delete`, method: 'POST', data: { id } }) },
  listSuppliers() { return request({ url: `${BASE}/purchase/suppliers`, method: 'POST', data: {} }) },
  exportPurchase(data) { return exportRequest(`${BASE}/purchase/export`, data) },

  // Usage
  saveUsage(data) { return request({ url: `${BASE}/usage/save`, method: 'POST', data }) },
  listUsage(data) { return request({ url: `${BASE}/usage/list`, method: 'POST', data }) },
  deleteUsage(id) { return request({ url: `${BASE}/usage/delete`, method: 'POST', data: { id } }) },
  exportUsage(data) { return exportRequest(`${BASE}/usage/export`, data) }
}
